import classNames from "classnames";
import React from "react";
import Callout from "web/react/components/callout/callout";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import { AppPreHeaderBarLanguageSelectorSerializer } from "web/types/serializers";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./pre-header-bar.css";

interface LanguageSelectorProps {
    calloutText: AppPreHeaderBarLanguageSelectorSerializer["callout_text"];
    choices: AppPreHeaderBarLanguageSelectorSerializer["choices"];
    numColumns: AppPreHeaderBarLanguageSelectorSerializer["num_columns"];
}

function LanguageSelector({
    calloutText,
    choices,
    numColumns,
}: LanguageSelectorProps): React.ReactElement {
    return (
        <Callout className={styles.action}>
            <Callout.CTA>
                <div className={styles.actionContainer}>
                    {calloutText}
                    <SVGIcon className={styles.chevronIcon} name="chevron" />
                </div>
            </Callout.CTA>
            <Callout.Content>
                <ul
                    className={classNames(
                        "app-header-dropdown-list",
                        styles.languageSelectorDropdown,
                        styles[`languageSelectorDropdown${numColumns}Columns`]
                    )}
                >
                    {choices.map((choice) => (
                        <li key={choice.url} className={styles.dropdownListItem}>
                            <TrackedButton
                                className={styles.dropdownListItemContent}
                                eventAction="clicked"
                                eventCategory="nav"
                                eventLabel="language_selector"
                                href={choice.url}
                            >
                                {choice.language_name}
                                {choice.is_selected && <SVGIcon name="tick" />}
                            </TrackedButton>
                        </li>
                    ))}
                </ul>
            </Callout.Content>
        </Callout>
    );
}

export default LanguageSelector;
